class clChangePassword
{

	private m_Modal: Dialog;
	private newPassword1: JQuery;
	private newPassword2: JQuery;

	constructor()
	{
		// Buttons
		const abortBtn = new Button( { title: app.getMessage( 'Aux.ABORT_BTN' ), style: 'danger',
				on: { }
		} );
		const submitBtn = new Button(
		{
			title: app.getMessage( 'Aux.SAVE_BTN' ), style: 'success',
			on:
			{
				click: () =>
				{
					if ( ( this.newPassword1.val() == this.newPassword2.val() ) && this.newPassword1.val() != '' )
					{
						this.saveChangedPassword( this.newPassword1.val() as string );
					}
					else
					{
						app.addToast( { body: [ app.getMessage( "Account.Password.FEHLERHAFT" ) ], context: 'danger', timeout: Number(app.getConfigValue("ToastTimeout")) } );
					}
				}
			}
		}
		);
		$( abortBtn.getElement() ).attr( 'data-dismiss', 'modal' );

		// Input Password
		const passform = new Form( { tag: 'div', orientation: 'horizontal' } );

		const passwordGroup1 = passform.newFormGroup( [ 1 ] );
		const in1Label = new InputLabel( { value: app.getMessage( "Account.Password.FIRST" ) } );
		const in1 = new InputPassword( { name: 'changePassword_1', value: '' } );
		passwordGroup1.addItem( { input: in1, label: in1Label } );
		this.newPassword1 = $( in1.getElement() );

		const passwordGroup2 = passform.newFormGroup( [ 1 ] );
		const in2Label = new InputLabel( { value: app.getMessage( "Account.Password.SECOND" ) } );
		const in2 = new InputPassword( { name: 'changePassword_2', value: '' } );
		passwordGroup2.addItem( { input: in2, label: in2Label } );
		this.newPassword2 = $( in2.getElement() );

		this.m_Modal = new Dialog(
		{
			closeBtn: true,
			fade: true,
			head: [ ui.h( 4, app.getMessage( "Account.Password.HEADER" ) ) ],
			body: [ passform.getElement() ],
			foot: [ abortBtn.getElement(), submitBtn.getElement() ],
			selfRemove: true
		}
		);
	}

	/*
	Passwort des aktuell angemeldeten Accounts wird aktualisiert
	*/
	public createModalChangePassword()
	{
		$( this.m_Modal.getElement() ).modal( 'show' );
	}

	/*
	Passwort wird auf NULL gesetzt, daraus folgt ein FirstLogin
	* param: AccountID
	*/
	public resetPassword( vAccount: Number )
	{

		new Wollmilch.AJAX(
		{
			url: 'account/resetPassword/' + vAccount,
			method: 'PATCH',
			data: {},
			on:
			{
				success( text: string ): void
				{
					let obj;
					try
					{
						obj = JSON.parse( text );
					}
					catch ( e )
					{
						alert( e.getMessage() );
						return;
					}
					if ( obj.success )
					{
						app.addToast( { body: [ app.getMessage( "Account.Password.SUCCESS" ) ], context: 'success', timeout: Number(app.getConfigValue("ToastTimeout")) } );
					}
					else
					{
						app.addToast( { body: [ app.getMessage( "Account.Password.ERROR" ) ], context: 'danger', timeout: Number(app.getConfigValue("ToastTimeout")) } );
					}
				},
				failed( status, xhr )
				{
					app.addToast( { timeout: Number(app.getConfigValue("ToastTimeout")), body: [xhr.responseText], context: 'danger' } );
				}
			}
		}
		).send();
	}

	private saveChangedPassword( newPassword: string )
	{
		const Account = app.getAuthenticationManager().getAccount();

		if ( !Account )
		{
			return;
		}

		new Wollmilch.AJAX(
			{
				url: 'account/changePassword/' + Account.ID,
				method: 'PATCH',
				data:
					{
						password: newPassword
					},
				on:
				{
					success: () =>
					{
						return ( text: string ): void =>
						{
							let obj;
							try
							{
								obj = JSON.parse( text );
							}
							catch ( e )
							{
								alert( e.getMessage() );
								return;
							}
							if ( obj.success )
							{
								app.addToast(
									{
										body: [ app.getMessage( "Account.Password.SUCCESS" ) ],
										context: 'success',
										timeout: Number(app.getConfigValue("ToastTimeout"))
									}
								);

								$( this.m_Modal.getElement() ).modal( 'hide' );
							}
							else
							{
								app.addToast(
									{
										body: [ app.getMessage( "Account.Password.ERROR" ) ],
										context: 'danger',
										timeout: Number(app.getConfigValue("ToastTimeout"))
									}
								);
							}

						};
					},
					failed( status, xhr )
					{
						app.addToast(
							{
								timeout: Number(app.getConfigValue("ToastTimeout")),
								body: [ xhr.responseText ],
								context: 'danger'
							}
						);
					}
				}
			}
		).send();
	}

}
